import { Node } from '@tiptap/core';
import Suggestion from '@tiptap/suggestion';
import { PluginKey } from 'prosemirror-state';
import { renderSlashMenuPopup } from './options';
export const SlashMenuPluginKey = new PluginKey('slash-menu');
export const SlashMenu = Node.create({
    name: 'slash-menu',
    addOptions() {
        return {
            HTMLAttributes: {},
            command: undefined,
            suggestion: {
                char: '/',
                pluginKey: SlashMenuPluginKey,
                // TODO: @Mehrad we should pass the document from the `useDocument` hook
                render: () => renderSlashMenuPopup({ document }),
            },
        };
    },
    group: 'inline',
    inline: true,
    atom: true,
    addProseMirrorPlugins() {
        return [
            Suggestion({
                editor: this.editor,
                command: this.options.command,
                ...this.options.suggestion,
            }),
        ];
    },
});
//# sourceMappingURL=index.js.map